// src/components/shared/PasswordInput.js
import React, { useState } from 'react';

const PasswordInput = ({ value, onChange, name = 'password', placeholder = 'Enter your password', minLength }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="form-group mb-3 position-relative">
      <input
        type={showPassword ? 'text' : 'password'}
        name={name}
        className="form-control pe-5"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        minLength={minLength}
        required
      />
      <i
        className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'}
        position-absolute top-50 end-0 translate-middle-y me-3`}
        style={{ cursor: 'pointer', fontSize: '1.2rem' }}
        onClick={() => setShowPassword(!showPassword)}
      />
    </div>
  );
};

export default PasswordInput;
